import { Context } from './types';

export * from '../reauth/guards';

export const isCaseInfoValid = (context: Context) => true;
